<app-product-files-prompt [sectionNumber]="4"
                          [allowSkip]="true"
                          sectionTitle="Product Tag Photo"
                          heroTitle="Great job! Next we’ll need a product tag."
                          heroImage="assets/consumer-mobile/product-tag-file.svg"
                          messageBody="Provide a photo of the tags on the furniture showing the SKU number and the serial number."
                          warningMessage="WARNING: Tags are often found on the underside or back of furniture. Please skip this step if there is a safety concern. We do not expect you to move or tip furniture unless it is within your physical capabilities."
                          (goToNextStep)="goNext()"></app-product-files-prompt>
